export const UPDATE_TASK_ERROR_MAP = {
	UNAUTHENTICATED_ERROR: { code: 'UNAUTHENTICATED_ERROR' },
	UNKNOWN_ERROR: { code: 'UNKNOWN_ERROR' },
} as const;

export const updateTaskErrorCodes = Object.keys(UPDATE_TASK_ERROR_MAP) as ReadonlyArray<
	keyof typeof UPDATE_TASK_ERROR_MAP
>;

export type UpdateTaskErrorCode = (typeof updateTaskErrorCodes)[number];

export function toErrorCode(serverMessage: string | null): UpdateTaskErrorCode {
	if (serverMessage === 'User must be authenticated') return UPDATE_TASK_ERROR_MAP.UNAUTHENTICATED_ERROR.code;
	return UPDATE_TASK_ERROR_MAP.UNKNOWN_ERROR.code;
}

export function parseUpdateTaskError(error: unknown): UpdateTaskErrorCode {
	const msg = error instanceof Error ? error.message : undefined;
	return updateTaskErrorCodes.find((v) => v === msg) ?? UPDATE_TASK_ERROR_MAP.UNKNOWN_ERROR.code;
}
